export default __webpack_public_path__ + "static/media/dp1.2af1098a.png";